import * as React from 'react'
import { memo } from 'react'
const SvgStar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.625 12">
    <path d="m6.312 9.646 3.9 2.354L9.18 7.56l3.443-2.985-4.54-.39L6.312 0 4.539 4.185l-4.536.39 3.44 2.985L2.411 12Z" />
  </svg>
)
const Memo = memo(SvgStar)
export default Memo
